import React from 'react';
import {date, price} from "../../../../util/formatting";

class ClientOrderListItem extends React.Component {
    static defaultProps = {
        item: {}
    };
    
    render() {
        if (!this.props.item || !this.props.model) {
            return;
        }
        
        return (
            <div className="list-item">
                <div className="list-item__column">
                    {this.props.model.title}<br/>
                    {this.props.model.note}
                </div>
                <div className="list-item__column">
                    {date(this.props.model.created)}
                </div>
                <div className="list-item__column">
                    {this.props.model.customer?.first_name} {this.props.model.customer?.last_name}<br/>
                    {this.props.model.customer?.email}
                </div>
                <div className="list-item__column">
                    Price: {price(this.props.model.total_price)}<br/>
                </div>
                {this.props.model.order && (
                    <div className="list-item__column">
                        Order: {this.props.model.order_id}<br/>
                    </div>
                )}
            </div>
        );
    }
}

export default ClientOrderListItem;